(function() {
  if (window.irCombinedReadMoreInit) return;
  window.irCombinedReadMoreInit = true;

  var CLASSES = {
    expanded: 'collapsible-combined--expanded',
    truncated: 'collapsible-combined--truncated',
    contentExpanded: 'collapsible-combined__content--expanded',
    contentTruncated: 'collapsible-combined__content--truncated',
    btnExpanded: 'collapsible-combined__read-more--expanded'
  };

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-combined-toggle]');
    if (!btn) return;
    e.preventDefault();

    var container = btn.closest('.collapsible-combined');
    var content = container && container.querySelector('[data-combined-content]');
    var textEl = btn.querySelector('[data-combined-text]');
    if (!container || !content || !textEl) return;

    var expand = btn.getAttribute('aria-expanded') !== 'true';

    container.classList.toggle(CLASSES.expanded, expand);
    container.classList.toggle(CLASSES.truncated, !expand);
    content.classList.toggle(CLASSES.contentExpanded, expand);
    content.classList.toggle(CLASSES.contentTruncated, !expand);
    btn.classList.toggle(CLASSES.btnExpanded, expand);
    btn.setAttribute('aria-expanded', String(expand));
    textEl.textContent = btn.dataset[expand ? 'labelLess' : 'labelMore'];

    if (!expand) {
      var section = container.closest('.collapsible-content');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
